<div class="dashboard--module-header">
    <h2 class="subheading-sm">Meter Read & consumption <button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button><span class="subheading--status" *ngIf="showProgress && consumerHasPayg" [ngClass]="{'text-color__warning': (progress == 'In Progress'), 'text-color__success': (progress == 'Completed'), 'text-color__error': (progress == 'Error')}">{{progress}}</span></h2><div class="ic-beware-wrapper" *ngIf="issues && issues.length > 0"><span class="ic-beware">!</span></div>
    <div class="btn-group">
        <!--<button class="focus-element"><span class="focus--content" tabindex="-1"><svg class="m-ic"><use xlink:href="#ic-edit" href="#ic-edit"></use></svg></span></button>-->
        <!--<button class="focus-element" *ngIf="progress != 'In Progress' && consumerHasPayg" (click)="getMeterInteraction()"><span class="focus--content" tabindex="-1" title="Request current meter read"><svg class="m-ic" [ngClass]="{'spin' : isProcessing}"><use xlink:href="#ic-refresh" href="#ic-refresh"></use></svg></span></button>-->
    </div>
</div>
<div class="module--main text-center">
    <div class="block-num text-center" *ngIf="latestMeterReads[0].length == 0 && latestMeterReads[1].length == 0">
        <span class="lg">N/A</span>
        <span class="sm">No meter consumption data</span>
    </div>
    <div class="flex-grid justify-center stack-sm">
        <div class="block-num max-width justify-center text-center" *ngIf="latestMeterReads[0].length > 0">
            <ul class="stacked-list">
                <li class="list--item" *ngFor="let latestMeterRead of latestMeterReads[0]">
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Heat'">
                        <use xlink:href="#ic-heat" href="#ic-heat"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Heat A'">
                        <use xlink:href="#ic-heat" href="#ic-heat"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Hot Water' || latestMeterRead.supplyName == 'Hot water'">
                        <use xlink:href="#ic-hot-water" href="#ic-hot-water"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Gas'">
                        <use xlink:href="#ic-gas" href="#ic-gas"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Chilling'">
                        <use xlink:href="#ic-chilled" href="#ic-chilled"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'VRF'">
                        <use xlink:href="#ic-vrf" href="#ic-vrf"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Cold Water'">
                        <use xlink:href="#ic-cold-water" href="#ic-cold-water"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Electricity'">
                        <use xlink:href="#ic-elec" href="#ic-elec"></use>
                    </svg>
                    <div class="text inline" *ngIf="latestMeterReads.length > 0">
                        <div><span class="h-uppercase h-bold h-text-sm block">{{latestMeterRead.supplyName}}</span></div>
                        <span class="lg">{{latestMeterRead.reading}}  ({{latestMeterRead.unitType}}) </span>
                        <span class="sm">{{latestMeterRead.readType}} read at {{latestMeterRead.readDate | date:'dd/MM/yyyy'}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="block-num max-width justify-center text-center" *ngIf="latestMeterReads[1].length > 0">
            <ul class="stacked-list">
                <li class="list--item" *ngFor="let latestMeterRead of latestMeterReads[1]">
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Heat'">
                        <use xlink:href="#ic-heat" href="#ic-heat"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Hot Water' || latestMeterRead.supplyName == 'Hot water'">
                        <use xlink:href="#ic-hot-water" href="#ic-hot-water"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Gas'">
                        <use xlink:href="#ic-gas" href="#ic-gas"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Chilling'">
                        <use xlink:href="#ic-chilled" href="#ic-chilled"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'VRF'">
                        <use xlink:href="#ic-vrf" href="#ic-vrf"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Cold Water'">
                        <use xlink:href="#ic-cold-water" href="#ic-cold-water"></use>
                    </svg>
                    <svg class="list--item-ic" *ngIf="latestMeterRead.supplyName == 'Electricity'">
                        <use xlink:href="#ic-elec" href="#ic-elec"></use>
                    </svg>
                    <div class="text inline" *ngIf="latestMeterReads.length > 0">
                        <div><span class="h-uppercase h-bold h-text-sm block">{{latestMeterRead.supplyName}}</span></div>
                        <span class="lg">{{latestMeterRead.reading}}   ({{latestMeterRead.unitType}}) </span>
                        <span class="sm">{{latestMeterRead.readType}} read at {{latestMeterRead.readDate | date:'dd/MM/yyyy'}}</span>
                    </div>
                </li>
            </ul>
        </div>
        <meter-consumption-chart [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData;else noData"></meter-consumption-chart>
        <ng-template #noData><p class="text-center">No meter consumption data available.</p></ng-template>
    </div>
</div>

